// extracted by mini-css-extract-plugin
export default {"ReplyItemContainer":"ReplyItemCollection_ReplyItemContainer__xm4Hk"};